export default "__VITE_ASSET__CkAm52C1__"